import * as types from './types';
import { loading, success, error } from 'State/actions';

export const getCaseTypes = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CASETYPES_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('stucasetype');
      dispatch(success(types.CASETYPES_FETCHED, response.data.Data));
    } catch (ex) {
      dispatch(error(types.CASETYPES_FETCH_ERROR, ex));
    }

    dispatch(loading(types.CASETYPES_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/state/caseTypes/actions.js